import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=85c04b3c&scoped=true&lang=pug"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=85c04b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c04b3c",
  null
  
)

/* custom blocks */
import block0 from "@locales/de/de.yml?namespace=ui.views.social_events.index?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fviews%2Fsocial_events%2FIndex.vue&locale=de&lang=yaml&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@locales/en/en.yml?namespace=ui.views.social_events.index?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fviews%2Fsocial_events%2FIndex.vue&locale=en&lang=yaml&external"
if (typeof block1 === 'function') block1(component)

export default component.exports